import { Redirect, Route, useLocation } from 'react-router-dom';

import Accounting from '../views/Accounting/Accounting';
import { CashbackBonus } from '../views/CashbackBonus/CashbackBonus';
import { CookiePolicy } from '../views/CookiePolicy/CookiePolicy';
import { EarningsBackoffice } from '../views/Earnings/Earnings';
import { Question } from '../views/HelpDesk/Question';
import { SubCategory } from '../views/HelpDesk/Subcategory';
import MyTeamBackofficeRoot from '../views/MyTeamBackoffice/MyTeamBackofficeRoot';
import { Orders } from '../views/Orders/Orders';
import { Portfolio } from '../views/Portfolio/Portfolio';
import { PrivacyPolicy } from '../views/PrivacyPolicy/PrivacyPolicy';
import { RankingRoot } from '../views/Ranking/RankingRoot';
import { Resources } from '../views/Resources/Resources';
import { TermsOfUse } from '../views/TermsOfUse/TermsOfUse';

import { EventPromoCruises } from '../views/EventPromo/EventPromoCruises';

import Dashboard from '../views/Dashboard/Dashboard';

import { Marketplace } from '../views/Marketplace/Marketplace';

import { BackofficeLayout } from '../layout/BackofficeLayout/BackofficeLayout';
import { HelpDesk } from '../views/HelpDesk/HelpDesk';
// import { Gaming } from '../views/Marketplace/Gaming/Gaming';
import { Payment } from '../views/Marketplace/Payment/Payment';
import {
  ACCOUNTING,
  AIRDROPS,
  AKASHA,
  BANGKOK_PROMOTION,
  BIG_WHALE,
  CASHBACK_BONUS,
  COOKIE_POLICY,
  CRUISES_PROMOTION,
  DASHBOARD,
  DEX_NET,
  DISCOUNT_CODE,
  EARNINGS,
  EARN_BET,
  ENTRY_PACKAGE,
  FLIPME_CARDS,
  HELPDESK,
  HELPDESK_QUESTION,
  HELPDESK_SUBCATEGORY,
  KRIPTO_TAP,
  // DUBAI_TOKEN_PROMOTION
  MANAGE_AKASHA_NODE,
  MARKETPLACE,
  MY_HUBS,
  MY_TEAM,
  ORDERS,
  // GAMING,
  PAYMENT,
  PRIVACY_POLICY,
  RANKING,
  RESOURCES,
  SETTINGS_TEAM_SETTINGS,
  STARTER,
  SUPPORT_TICKETS,
  TERMS_OF_USE,
  TRADING,
  TRAVEL_PACKAGES
} from './routes';
import { SettingsRoutes } from './settingsRoutes';

import { EventPromoBangkok } from '../views/EventPromo/EventPromoBangkok';

import { useAppSelector } from '../app/hooks';
import { UserTypes } from '../types/loginTypes';
// import { DiscountCode } from '../views/DiscountCode/DiscountCode';
import { Airdrops } from '../views/Airdrops/Airdrops';
import { EarnBet } from '../views/EarnBet/EarnBet';
import { Akasha } from '../views/Marketplace/Akasha/Akasha';
import { BigWhale } from '../views/Marketplace/BigWhale/BigWhale';
import { DexNet } from '../views/Marketplace/DexNet/DexNet';
import { FlipmeCards } from '../views/Marketplace/FlipmeCards/FlipmeCards';
import { KriptoTap } from '../views/Marketplace/KriptoTap/KriptoTap';
import { StarterPackages } from '../views/Marketplace/StarterPackages/StarterPackages';
import { TravelPackages } from '../views/Marketplace/TravelPackages/TravelPackages';
import { ManageAkashaNode } from '../views/Portfolio/ManageAkashaNode';
import SupportTickets from '../views/SupportTickets/SupportTickets';
import { EntryPackages } from '../views/Marketplace/EntryPackage/EntryPackage';
// import { DubaiTokenPromo } from '../views/DubaiTokenPromo/DubaiTokenPromo';

export const BackofficeRoutes = () => {
  const { userInfo } = useAppSelector((state) => state.auth);

  const isRestrictedUser = userInfo.userType === UserTypes.Restricted;

  const location = useLocation();

  const pathname = location.pathname;

  const isRestrictedPath =
    isRestrictedUser &&
    (pathname === DASHBOARD ||
      pathname === MY_TEAM ||
      pathname === EARNINGS ||
      pathname === RANKING ||
      pathname === RESOURCES);

  const {
    isCanadaRestrictedUser,
    isJapanRestrictedUser,
    canBuyBigWhale,
    canBuyFlipMePackages,
    canBuyTravelPackages,
    canBuyStakingPackages,
    canBuyAkashaPackages
  } = userInfo;

  const isCanadaRestrictedPath =
    isCanadaRestrictedUser &&
    (pathname === MARKETPLACE ||
      pathname === PAYMENT ||
      pathname === TRADING ||
      pathname === BIG_WHALE ||
      pathname === DISCOUNT_CODE ||
      pathname === RESOURCES ||
      pathname === CASHBACK_BONUS ||
      pathname === SETTINGS_TEAM_SETTINGS);

  const isJapanRestrictedPath = !isJapanRestrictedUser && pathname === PAYMENT;

  const isHungaryRestrictedPath = !canBuyBigWhale && pathname === BIG_WHALE;

  const isTravelPackegesRestrictedPath =
    !canBuyTravelPackages && pathname === TRAVEL_PACKAGES;

  const isAkashaPackegesRestrictedPath =
    !canBuyAkashaPackages && pathname === AKASHA;

  const isFlipmePackegesRestrictedPath =
    !canBuyFlipMePackages && pathname === FLIPME_CARDS;

  const isStakingPackegesRestrictedPath =
    !canBuyStakingPackages && pathname === MARKETPLACE;

  return (
    <BackofficeLayout>
      {isRestrictedPath && <Redirect to={MY_HUBS} />}
      {isTravelPackegesRestrictedPath && <Redirect to={DASHBOARD} />}
      {isAkashaPackegesRestrictedPath && <Redirect to={DASHBOARD} />}
      {isCanadaRestrictedPath && <Redirect to={DASHBOARD} />}
      {isFlipmePackegesRestrictedPath && <Redirect to={DASHBOARD} />}
      {isJapanRestrictedPath && <Redirect to={DASHBOARD} />}
      {isHungaryRestrictedPath && <Redirect to={DASHBOARD} />}
      {isStakingPackegesRestrictedPath && <Redirect to={DASHBOARD} />}

      <Route exact path={`${DASHBOARD}`} render={() => <Dashboard />} />

      <Route exact path={`${ORDERS}`} render={() => <Orders />} />

      <Route path={`${MY_HUBS}/:tab?`} render={() => <Portfolio />} />

      <Route
        path={`${MANAGE_AKASHA_NODE}/:id`}
        render={() => <ManageAkashaNode />}
      />

      <Route
        exact
        path={`${MY_TEAM}`}
        render={() => <MyTeamBackofficeRoot />}
      />

      <Route exact path={`${EARNINGS}`} render={() => <EarningsBackoffice />} />

      <Route exact path={`${RANKING}`} render={() => <RankingRoot />} />

      <Route exact path={`${RESOURCES}`} render={() => <Resources />} />

      <Route
        exact
        path={`${HELPDESK}/:categoryId?`}
        render={(props) => <HelpDesk {...props} />}
      />

      <Route
        exact
        path={`${HELPDESK_SUBCATEGORY}/:id?/:subId?`}
        render={(props) => <SubCategory {...props} />}
      />

      <Route
        exact
        path={`${HELPDESK_QUESTION}/:id?/:categoryId?/:subId?`}
        render={(props) => <Question {...props} />}
      />

      <Route exact path={`${ACCOUNTING}`} render={() => <Accounting />} />

      <Route
        exact
        path={`${CASHBACK_BONUS}`}
        render={() => <CashbackBonus />}
      />

      <Route exact path={`${TERMS_OF_USE}`} render={() => <TermsOfUse />} />

      <Route
        exact
        path={`${PRIVACY_POLICY}`}
        render={() => <PrivacyPolicy />}
      />

      <Route exact path={`${COOKIE_POLICY}`} render={() => <CookiePolicy />} />

      <Route
        exact
        path={`${TRAVEL_PACKAGES}`}
        render={(props) => <TravelPackages />}
      />

      <Route exact path={`${AIRDROPS}`} render={(props) => <Airdrops />} />

      <Route
        exact
        path={`${CRUISES_PROMOTION}`}
        render={(props) => <EventPromoCruises />}
      />

      <Route
        exact
        path={`${BANGKOK_PROMOTION}`}
        render={(props) => <EventPromoBangkok />}
      />

      <Route exact path={`${PAYMENT}`} render={() => <Payment />} />

      <Route exact path={`${AKASHA}`} render={() => <Akasha />} />

      <Route exact path={`${KRIPTO_TAP}`} render={() => <KriptoTap />} />

      <Route exact path={`${STARTER}`} render={() => <StarterPackages />} />

      <Route exact path={`${DEX_NET}`} render={() => <DexNet />} />

      <Route exact path={`${ENTRY_PACKAGE}`} render={() => <EntryPackages />} />

      <Route exact path={`${FLIPME_CARDS}`} render={() => <FlipmeCards />} />

      <Route exact path={`${MARKETPLACE}`} render={() => <Marketplace />} />

      <Route
        exact
        path={`${SUPPORT_TICKETS}`}
        render={() => <SupportTickets />}
      />

      {canBuyBigWhale && (
        <Route exact path={`${BIG_WHALE}`} render={() => <BigWhale />} />
      )}

      <Route exact path={`${EARN_BET}`} render={() => <EarnBet />} />

      {/* <Route
        exact
        path={`${DUBAI_TOKEN_PROMOTION}`}
        render={() => <DubaiTokenPromo />}
      /> */}

      <Route
        exact
        path={'/backoffice/settings/:path?'}
        render={() => (
          <SettingsRoutes isCanadaRestrictedUser={isCanadaRestrictedUser} />
        )}
      />
    </BackofficeLayout>
  );
};
